<template>
  <div>
    <b-button
      block
      variant="custom-style"
      v-b-toggle="item"
      :disabled="false"
      size="sm"
      class="accordion-button my-1"
      :style="calloutStyle"
      @click="buttonClicked(item)"
    >
      <b-row>
        <b-col>
          <div class="text-left">
            <span>
              {{ $t('drivers.categories.' + item.toUpperCase()) }}
            </span>
          </div>
        </b-col>
        <b-col>
          <div class="text-right">
            <span>
              <i class="fas fa-chevron-circle-down"></i>
            </span>
          </div>
        </b-col>
      </b-row>
    </b-button>

    <b-collapse accordion="data-accordion" class="mt-2 mb-2" :id="item">
      <slot name="accordion-content"></slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    item: {},
    accordionButtonClass: Array,
    calloutStyle: String,
  },
  methods: {
    buttonClicked(data) {
      this.$emit('button-clicked', data)
    },
  },
}
</script>

<style lang="scss" scoped>
.accordion-button {
  font-size: 0.8rem;
  background-color: #eee !important;
}
.accordion-button.collapsed .fa-chevron-circle-down {
  transform: rotateX(0deg);
  color: #343a40 !important;
}
.accordion-button .fa-chevron-circle-down {
  color: var(--primary) !important;
  transition: transform 0.5s;
  transform: rotateZ(180deg);
}
</style>
